import { render, staticRenderFns } from "./clubProfile.vue?vue&type=template&id=4af0bbc0&scoped=true&"
import script from "./clubProfile.vue?vue&type=script&lang=js&"
export * from "./clubProfile.vue?vue&type=script&lang=js&"
import style0 from "./clubProfile.vue?vue&type=style&index=0&id=4af0bbc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af0bbc0",
  null
  
)

export default component.exports